import _                                  from 'underscore';
import React, { FC }                      from 'react';
import styled                             from 'styled-components';
import { CorvalUIColor, SemanticUIColor } from '../../../../types';
import { getCSSVar }                      from '../../../../util/BrowserUtility';

export interface DotShapeProps {

    // Dot shape size (width / height)
    size?: number,

    // Any CorvalUIColor, SemanticUIColor, or PROJECT_ENTITY_SUPPORTED_COLORS
	color?: string

	[ additionalProps: string ]: any
}

const defaultProps: DotShapeProps = {
	size:  100,
	color: SemanticUIColor.TEAL,
}

const Dot = styled.span<DotShapeProps>`
	position: relative;
	display: inline-block;
    width: ${ props => props.size }px;
    height: ${ props => props.size }px;
    background: ${ props => props.color };
    border-radius: 50%;
`;

const DotShape: FC<DotShapeProps> = ( props ) => {

	let color = getCSSVar( `--color-${ props.color }`, props.color ),
	    size  = props.size;

	return <Dot size={ size } color={ color }/>;
};

DotShape.defaultProps = defaultProps;

export { DotShape }
